import React, { SVGProps } from 'react';

const SvgMail = (props: SVGProps<SVGSVGElement>) => (
    <svg width={59.332} viewBox="0 0 59.332 59.332" {...props}>
        <path
            data-name="Path 2677"
            d="m49.598 11.969 8.575 8.422V50.12a8.054 8.054 0 0 1-8.054 8.054H9.213a8.054 8.054 0 0 1-8.054-8.054V20.391l8.515-8.515Z"
            fill="#ffc400"
        />
        <path
            data-name="Path 2678"
            d="m39.282 39.282 10.316-10.316V4.635a3.476 3.476 0 0 0-3.477-3.476H13.21a3.476 3.476 0 0 0-3.476 3.476v24.33L20.05 39.282l9.616-5.229Z"
            fill="#fff"
        />
        <g data-name="Group 830" fill="#12b05e">
            <path
                data-name="Path 2679"
                d="m49.598 11.969 8.575 8.422-8.575 8.575Z"
            />
            <path
                data-name="Path 2680"
                d="m9.734 11.969-8.575 8.417 8.575 8.575Z"
            />
        </g>
        <path
            data-name="Path 2681"
            d="M43.413 57.014h-.015a1.159 1.159 0 0 0 0 2.318h.015a1.159 1.159 0 1 0 0-2.318Z"
        />
        <path
            data-name="Path 2682"
            d="m58.989 19.568-8.233-8.175V4.635A4.641 4.641 0 0 0 46.121 0h-32.91a4.641 4.641 0 0 0-4.636 4.635v6.7L.339 19.571A1.16 1.16 0 0 0 0 20.39v29.729a9.223 9.223 0 0 0 9.213 9.213h29.02a1.159 1.159 0 1 0 0-2.318H9.213a6.851 6.851 0 0 1-3.69-1.075L7.7 53.767h17.8a1.159 1.159 0 1 0 0-2.318H10.013l13.823-13.823a8.254 8.254 0 0 1 11.659 0l18.314 18.313a6.851 6.851 0 0 1-3.689 1.075h-1.565a1.159 1.159 0 1 0 0 2.318h1.564a9.175 9.175 0 0 0 6.147-2.358 1.167 1.167 0 0 0 .116-.1c.015-.015.029-.032.043-.048a9.186 9.186 0 0 0 2.907-6.707V20.39a1.159 1.159 0 0 0-.343-.822Zm-2.458.825-5.775 5.775V14.659ZM8.575 26.168 2.8 20.39l5.778-5.778ZM2.318 50.119V23.188l16.339 16.34L3.8 54.384a6.859 6.859 0 0 1-1.482-4.265ZM22.2 35.987l-1.9 1.9-9.4-9.4V4.635a2.32 2.32 0 0 1 2.318-2.318h32.903a2.32 2.32 0 0 1 2.318 2.318v23.85l-9.4 9.4-1.9-1.9a10.575 10.575 0 0 0-14.939.002Zm33.333 18.4L40.675 39.528l16.339-16.34v26.931a6.859 6.859 0 0 1-1.483 4.265Z"
        />
        <path
            data-name="Path 2683"
            d="M18.719 12.979h11.643a1.159 1.159 0 1 0 0-2.318H18.719a1.159 1.159 0 1 0 0 2.318Z"
        />
        <path
            data-name="Path 2684"
            d="M35.73 12.979a1.159 1.159 0 1 0-.819-.34 1.172 1.172 0 0 0 .819.34Z"
        />
        <path
            data-name="Path 2685"
            d="M18.719 21.323h21.895a1.159 1.159 0 1 0 0-2.318H18.719a1.159 1.159 0 1 0 0 2.318Z"
        />
        <path
            data-name="Path 2686"
            d="M41.773 28.507a1.159 1.159 0 0 0-1.159-1.159h-21.9a1.159 1.159 0 1 0 0 2.318h21.895a1.159 1.159 0 0 0 1.164-1.159Z"
        />
    </svg>
);
export default SvgMail;
